var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.2039C1 8.91549 1 7.77128 1.5192 6.82274C2.0384 5.87421 2.98695 5.28551 4.88403 4.10813L6.88403 2.86687C8.88939 1.62229 9.8921 1 11 1C12.1079 1 13.1106 1.62229 15.116 2.86687L17.116 4.10812C19.0131 5.28551 19.9616 5.87421 20.4808 6.82274C21 7.77128 21 8.91549 21 11.2039V12.725C21 16.6258 21 18.5763 19.8284 19.7881C18.6569 21 16.7712 21 13 21H9C5.22876 21 3.34315 21 2.17157 19.7881C1 18.5763 1 16.6258 1 12.725V11.2039Z",
    stroke: "#A4A4A4",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.36075d23cafbadc055a17e809e8d190a.svg";
export { ForwardRef as ReactComponent };